// extracted by mini-css-extract-plugin
export default {"serviceSection":"serviceSection__NmFkN","image":"image__MWVjY","heading":"heading__MzE4Z"};